/*eslint-disable*/module.exports={messages:{"Visitor's Badge":"Pase Visitante"}};